'use client';

import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { RootState } from '@/store/store';
import { useStore } from '@/store/store';
import { useRecentGamesSync } from '@/hooks/use-recent-games-sync/use-recent-games-sync';

type NewCategoryContextValue = {
    newToYouUIDs: Set<string>;
};

const NewCategoryContext = createContext<NewCategoryContextValue>({ newToYouUIDs: new Set() });

export const NewCategoryProvider = ({ newToYouUIDs, children }: { newToYouUIDs: string[]; children: ReactNode }) => {
    useRecentGamesSync();
    const recentGames = useStore((state: RootState) => state.userContext.recentGames);

    const value = useMemo(() => {
        const recentSet = new Set(recentGames);
        return { newToYouUIDs: new Set(newToYouUIDs.filter((uid) => !recentSet.has(uid))) };
    }, [newToYouUIDs, recentGames]);

    return <NewCategoryContext.Provider value={value}>{children}</NewCategoryContext.Provider>;
};

export const useNewCategory = () => useContext(NewCategoryContext);
